<template>
  <v-card>
    <v-card-title>
      <span class="headline">Indicators Setting</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text style="padding-bottom: 0;">
      <v-row>
        <v-col cols="4">
          <div v-for="(item, index) in indicator" :key="index" style="width:100%;display: flex;padding: 5px 0">
            <template v-if="item.key === dataType.IndicatorEnum.HIGH_RISK.key">
              <span style="width: 30%;margin-top: 10px">{{ item.text }}</span>
              <v-checkbox
                label="Found"
                v-model="item.firstCheckbox"
                v-on:change="clearInput(1, item.indicatorCode)"
                color="primary"
                hide-details
                style="padding: 0;margin: 10px 0 0;width: 30%"
                :disabled="isIndicatorDisabled"
              ></v-checkbox>
            </template>
            <template v-else-if="item.right">
              <span style="width: 30%">{{ item.text }}</span>
              <v-checkbox
                label="Found"
                v-model="item.firstCheckbox"
                v-on:change="clearInput(1, item.indicatorCode)"
                color="primary"
                hide-details
                style="padding: 0;margin: 0;width: 30%"
                :disabled="isIndicatorDisabled"
              ></v-checkbox>
              <v-text-field
                v-if="item.firstCheckbox"
                v-model="item.count"
                @blur.prevent="validateInput(1, item)"
                hide-details
                single-line
                :disabled="isIndicatorDisabled"
                type="number"
                style="width: 40%;margin: 0;padding: 0"
                height="20"
              ></v-text-field>
            </template>
          </div>
        </v-col>
        <v-col cols="1"></v-col>
        <v-col cols="7" style="padding: 5px">
          <div v-for="(item, index) in indicator" :key="index" style="width:100%;display: flex;padding: 5px 0">
            <template v-if="item.hasLatestIn">
              <span style="width: 20%">{{ item.text }}</span>
              <v-checkbox
                label="Found"
                v-model="item.firstCheckbox"
                v-on:change="clearInput(1, item.indicatorCode)"
                color="primary"
                hide-details
                style="padding: 0;margin: 0;width: 14%"
                :disabled="isIndicatorDisabled"
              ></v-checkbox>
              <v-text-field
                v-show="item.firstCheckbox"
                v-model="item.count"
                @blur.prevent="validateInput(1, item)"
                hide-details
                single-line
                :disabled="isIndicatorDisabled"
                type="number"
                style="margin: 0;padding: 0 5px; max-width: 21%"
                height="20"
              ></v-text-field>
              <v-checkbox
                label="Latest In"
                v-model="item.secondCheckbox"
                v-on:change="clearInput(2, item.indicatorCode)"
                v-show="item.firstCheckbox"
                color="primary"
                hide-details
                :disabled="isIndicatorDisabled"
                style="padding: 0;margin: 0;width: 18%"
              ></v-checkbox>
              <v-text-field
                v-show="item.firstCheckbox && item.secondCheckbox"
                v-model="item.latestIn"
                @blur.prevent="validateInput(2, item)"
                hide-details
                single-line
                :disabled="isIndicatorDisabled"
                type="number"
                style="max-width: 21%;margin: 0;padding: 0"
                height="20"
              ></v-text-field>
            </template>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" style="padding-top: 0">
          <div v-for="(item, index) in indicator" :key="index">
            <template v-if="item.key === dataType.IndicatorEnum.HIGH_RISK.key">
              <v-textarea
                v-if="item.firstCheckbox"
                textarea
                hide-details
                v-model="item.notes"
                style="padding: 0;margin: 0;"
              ></v-textarea>
            </template>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn text @click="updateIndicatorsSetting">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { OriginationApi } from '@/api/pandaria'
import { DataType, Tool, Popup } from '@/util/index'

const tool = new Tool()
const popup = new Popup()
export default {
  name: 'indicators-setting-dialog',
  props: {
    loan: {
      type: Object,
      default: () => {}
    },
    indicatorArray: {
      type: Array,
      default: () => []
    },
    display: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      indicator: [],
      countReg: /^[0-9]*$/,
      latestInReg: /^[0-9]*$/,
      isSave: true,
      dataType: DataType,
      tool: tool
    }
  },
  computed: {
    isIndicatorDisabled () {
      return false
    }
  },
  watch: {
    display (val) {
      if (val) {
        this.initIndicatorsSetting()
      }
    }
  },
  mounted () {
    this.initIndicatorsSetting()
  },
  methods: {
    getTextFieldClassByIndex (index) {
      if (index % 2 === 0) {
        return 'lg1'
      } else {
        return 'lg2'
      }
    },
    hideDialog () {
      this.$emit('hideDialog')
    },
    initIndicatorsSetting () {
      this.indicator = JSON.parse(JSON.stringify(this.indicatorArray))
    },
    updateIndicatorsSetting () {
      this.isSave = true
      const saveData = []
      const $this = this
      for (const indicatorItem of this.indicator) {
        const saveDataItem = {}
        saveDataItem.loanId = indicatorItem.loanId
        saveDataItem.indicatorCode = indicatorItem.indicatorCode
        saveDataItem.count = tool.isEmpty(indicatorItem.count) ? '' : Number(indicatorItem.count)
        saveDataItem.latestIn = tool.isEmpty(indicatorItem.count) ? '' : indicatorItem.latestIn
        saveDataItem.notes = indicatorItem.notes
        saveData.push(saveDataItem)
        if (!(tool.isEmpty(saveDataItem.count) || (this.countReg.test(saveDataItem.count) && (parseInt(saveDataItem.count) >= 0 && parseInt(saveDataItem.count) <= 100)))) {
          this.isSave = false
        }
        if (!(tool.isEmpty(saveDataItem.latestIn) || (this.latestInReg.test(saveDataItem.latestIn) && saveDataItem.latestIn.toString().length === 4))) {
          this.isSave = false
        }
      }
      if (this.isSave) {
        const updateFeaturesData = {
          loanId: $this.loan.id,
          feature: 'INDICATOR',
          data: saveData
        }
        OriginationApi.updateSectionFeature(updateFeaturesData, function (result) {
          $this.$emit('indicatorDataUpdate', saveData)
        }, function (result) {
          popup.popupForError(result.message)
        })
        $this.$emit('hideDialog')
      } else {
        popup.popupForInfo('Unable to save, please input correct data', { title: 'Failure' })
      }
    },
    clearInput (location, indicatorCode) {
      const $this = this
      for (const index in this.indicator) {
        if (this.indicator[index].indicatorCode === indicatorCode) {
          if (indicatorCode === DataType.IndicatorEnum.HIGH_RISK.value) {
            $this.indicator[index].notes = ''
          } else if (location === 1) {
            if (!this.indicator[index].firstCheckbox) {
              $this.indicator[index].count = ''
              $this.indicator[index].latestIn = ''
            }
          } else if (location === 2) {
            if (!this.indicator[index].secondCheckbox) {
              $this.indicator[index].latestIn = ''
            }
          }
        }
      }
    },
    validateInput (location, item) {
      const { count, latestIn } = item
      if (location === 1) {
        this.ruleCount(count)
      } else if (location === 2) {
        this.ruleLatestIn(latestIn)
      }
    },
    ruleCount (count) {
      if (tool.isEmpty(count) || (this.countReg.test(count) && (parseInt(count) >= 0 && parseInt(count) <= 100))) {
        return true
      } else {
        popup.popupForError('Please enter an integer between 0 and 100')
        return false
      }
    },
    ruleLatestIn (latestIn) {
      if (tool.isEmpty(latestIn) || (this.latestInReg.test(latestIn) && latestIn.toString().length === 4)) {
        const year = new Date().getUTCFullYear()
        if (latestIn > year) {
          popup.popupForError('Latest In should be smaller than this year')
          return false
        }
        return true
      } else {
        popup.popupForError('Please enter a four digit year')
        return false
      }
    }
  }
}
</script>
